module.exports = __webpack_public_path__ + "static/media/assign budget.5e41fc52.svg";